import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Button from "@weave-design/button";
import { Attach24 } from "@weave-design/icons";
import { ProcessingFailure } from "../../../../processing-failure/processingFailure";
import { ProcessingPane } from "../../../../processing-pane/processingPane";
import { rootElement } from "../../../../shared";
import { PrimaryModelsList } from "./primaryModelsList";
import { LinkedModelView } from "../../../eventBus/linkedModelsEventPayloads";
import eventBus, { IApplicationEvent } from "../../../eventBus/eventDispatcher";
import repo from "../../../../../Repository";

type Props = {
    modelId: string;
    projectId: string;
};

export const LinkPrimaryModel = ({ modelId, projectId }: Props) => {
    const [isDialogOpened, setIsDialogOpened] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [failure, setFailure] = useState("");

    useEffect(() => {
        const onToggleVisibility = (event: IApplicationEvent<boolean>) => {
            if (!event.payload) {
                setIsDialogOpened(false);
                setInProgress(false);
                setFailure("");
            }
        };

        eventBus.addEventListener("Dextall.LinkedModels.UI.DockingPanelVisibilityChanged", onToggleVisibility);

        return () => {
            eventBus.removeEventListener("Dextall.LinkedModels.UI.DockingPanelVisibilityChanged", onToggleVisibility);
        };
    }, []);

    const addNewModel = async (model: LinkedModelView) => {
        setIsDialogOpened(false);
        setInProgress(true);

        const response = await repo.assignPrimaryLinkedModel({
            modelId,
            primaryLinkedModelId: model.id,
        });

        setInProgress(false);

        if (response.isSuccess) {
            eventBus.dispatchEvent({ type: "Dextall.LinkedModels.Created", payload: response.item });
        } else {
            setFailure(response.message);
        }
    };

    return (
        <>
            <Button
                className="link-primary-model"
                type="secondary"
                size="standard"
                title="Add existing"
                width="grow"
                icon={<Attach24 />}
                onClick={() => setIsDialogOpened(true)}
            />

            {isDialogOpened && (
                <PrimaryModelsList
                    projectId={projectId}
                    selectModel={addNewModel}
                    close={() => setIsDialogOpened(false)}
                />
            )}

            {inProgress &&
                ReactDOM.createPortal(
                    <ProcessingPane isVisible message="Linking model..." title="Linked model" />,
                    rootElement,
                )}

            {failure &&
                ReactDOM.createPortal(
                    <ProcessingFailure
                        isVisible
                        title="Linked model"
                        message={failure}
                        closeProcessingErrorDialog={() => setFailure("")}
                    />,
                    rootElement,
                )}
        </>
    );
};
